<dx-lookup
  #lookup
  [dataSource]="data"
  [valueExpr]="key"
  [value]="selectedItem"
  [displayExpr]="displayExpr"
  [searchEnabled]="enableSearch"
  [disabled]="disabled"
  [placeholder]="placeholder"
  (onValueChanged)="valueChanged($event)"
  [showClearButton]="showClearButton"
  [width]="width"
  [elementAttr]="title ? { title: title } : null"
>
  <div *dxTemplate="let data of 'item'">
    <span [title]="displayExpr(data)">{{ displayExpr(data) }}</span>
  </div>
  <dxo-drop-down-options [showTitle]="false"></dxo-drop-down-options>
</dx-lookup>
